<script lang="ts">
	import Home from "@svg/Home.svelte";
	import Person from "@svg/Person.svelte";
	import Movie from "@svg/Movie.svelte";
	import FavoriteIcon from "@svg/FavoriteIcon.svelte";
	import { query } from "@stores/searchQuery";

	export let pathname: string | null = null;

	const navItems = [
		{ href: "/", icon: Home, match: (path: string) => path === "/" },
		{
			href: "/videos",
			icon: Movie,
			match: (path: string) => path?.includes("/videos")
		},
		{
			href: "/favourites",
			icon: FavoriteIcon,
			match: (path: string) => path?.includes("/favourites")
		},
		{
			href: "/profile",
			icon: Person,
			match: (path: string) => path?.includes("/profile")
		}
	];
</script>

<footer
	class="flex h-12 w-full border-t border-gray-200 bg-white shadow-sm lg:hidden"
>
	{#each navItems as { href, icon: Icon, match }}
		{@const active = pathname ? match(pathname) : false}
		<a
			data-astro-prefetch="tap"
			class="active:text-secondary flex basis-1/4 items-center justify-center transition-colors hover:bg-gray-50
				{active && 'text-secondary'}
			"
			{href}
			on:click={() => {
				$query = "";
			}}
		>
			<Icon class="h-6 w-6 fill-current" filled={active} />
		</a>
	{/each}
</footer>
